import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  REFRESH_TOKEN,
  SWITCH_ACCOUNT,
} from "./actionTypes"
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  refreshTokenSuccess,
} from "./actions"

// import helpers functions
import {
  postEmailLogin,
  postLogout,
  postRefreshToken,
  switchAccount,
} from "helpers/AuthType/auth_helper"
import { apiErrorrHandler } from "utils/apiErrorHandler"
import { encryptData, NotificationMessage } from "utils"
import { messages } from "common/data"

// after Login setup
const loginLocalStorage = ({
  expires_in,
  authUser,
  access_token,
  token_type,
  isCustomer,
  isReinsurer,
}) => {
  const expiredDate = new Date()
  expiredDate.setSeconds(expiredDate.getSeconds() + (expires_in - 300))
  localStorage.setItem("authUser", JSON.stringify(authUser))
  localStorage.setItem(
    "accessToken",
    JSON.stringify({ access_token, expires_in: expiredDate, token_type })
  )

  const userSource =
    authUser?.sources?.length > 0 ? authUser?.sources[0] : authUser?.source

  if (isCustomer) {
    // source type
    localStorage.setItem("mainCustomer", encryptData(userSource))
    localStorage.removeItem("mainReinsurer")
  }
  if (isReinsurer) {
    localStorage.setItem("mainReinsurer", encryptData(userSource))
    localStorage.removeItem("mainCustomer")
  }
}

function* loginUser({ payload: { user, afterLoginCB } }) {
  try {
    const response = yield call(postEmailLogin, {
      username: user.username,
      password: user.password,
    })
    const {
      access_token,
      expires_in,
      token_type,
      user: authUser,
    } = response.item

    // if user access type not customer nor reinsurer reject the user
    // and not complete the login

    const allowedSourceTypes = ["customer", "reinsurer"]
    const userSourceType = authUser?.access_type?.source_type?.toLowerCase()
    if (!allowedSourceTypes.includes(userSourceType)) {
      yield put(apiError(messages.wrongPortalCredentials))
      return
    }

    const isCustomer = userSourceType === "customer" ? true : false
    const isReinsurer = userSourceType === "reinsurer" ? true : false

    loginLocalStorage({
      access_token,
      expires_in,
      token_type,
      authUser,
      isCustomer,
      isReinsurer,
    })
    yield put(loginSuccess(response.item))
    if (afterLoginCB) {
      afterLoginCB()
    }

    window.location.href = "/"
  } catch (error) {
    console.log(error)
    const errorMessage = apiErrorrHandler(error)
    yield put(apiError(errorMessage))
  }
}

// Switch Account

function* switchUserAccount({ payload: { newAccountId } }) {
  try {
    const response = yield call(switchAccount, {
      linked_user_id: newAccountId,
    })
    const {
      access_token,
      expires_in,
      token_type,
      user: authUser,
    } = response.item

    // if user access type not customer nor reinsurer reject the user
    // and not complete the login

    const allowedSourceTypes = ["customer"]
    const userSourceType = authUser?.access_type?.source_type?.toLowerCase()
    if (!allowedSourceTypes.includes(userSourceType)) {
      yield put(apiError(messages.wrongPortalCredentials))
      NotificationMessage("errro", "Can’t Switch To This User")
      return
    }

    const isCustomer = userSourceType === "customer" ? true : false

    loginLocalStorage({
      access_token,
      expires_in,
      token_type,
      authUser,
      isCustomer,
      isReinsurer: false,
    })

    yield put(loginSuccess(response.item))
    NotificationMessage("success", response?.message)
    window.location.reload()
  } catch (error) {
    console.log(error)
    const errorMessage = apiErrorrHandler(error)
    yield put(apiError(errorMessage))
  }
}

function* logoutUser() {
  try {
    const response = yield call(postLogout)
    yield put(logoutUserSuccess(response))
    localStorage.removeItem("authUser")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("TPACurrency")
    localStorage.removeItem("mainCustomer")
    localStorage.removeItem("mainReinsurer")
    window.location.replace("/login")
  } catch (error) {
    const errorMessage = apiErrorrHandler(error)
    yield put(apiError(errorMessage))
    console.log(error)
  }
}
function* refreshToken() {
  try {
    const response = yield call(postRefreshToken)
    const { access_token, expires_in, token_type } = response.item
    yield put(refreshTokenSuccess(response.item))

    // if (localStorage.getItem("accessToken") !== null) {
    //   localStorage.setItem("accessToken", JSON.stringify(response.item))
    // }

    const expiredDate = new Date()
    expiredDate.setSeconds(expiredDate.getSeconds() + (expires_in - 300))
    localStorage.setItem(
      "accessToken",
      JSON.stringify({ access_token, expires_in: expiredDate, token_type })
    )

    console.log(response)
  } catch (error) {
    const errorMessage = apiErrorrHandler(error)

    yield put(apiError(errorMessage))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(SWITCH_ACCOUNT, switchUserAccount)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(REFRESH_TOKEN, refreshToken)
}

export default authSaga
